import React, {cloneElement, useEffect, useState} from 'react';
import {Animated, Image, View} from 'react-native';
import {useTheme} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';
import styles from './styles';
import {TickIcon} from '../../../utils/SvgIcons';

const RippleAnimation = ({
  size = 200,
  color,
  icon = <TickIcon />,
  iconType = 'svg',
  iconTintColor,
  iconSize = 42,
  imageStyle = {},
}) => {
  // Themed DEFAULTS only (legacy blueMain3 → accent, white → textOnAccent;
  // identical in light). Explicit color props still win.
  const {colors} = useTheme();
  const resolvedColor = color === undefined ? colors.accent : color;
  const resolvedIconTintColor =
    iconTintColor === undefined ? colors.textOnAccent : iconTintColor;
  const [animated, setAnimated] = useState(new Animated.Value(0.3));
  const [opacitiA, setOpacitiA] = useState(new Animated.Value(1));
  const [animated2, setAnimated2] = useState(new Animated.Value(0.3));
  const [opacitiA2, setOpacitiA2] = useState(new Animated.Value(1));
  const [animated3, setAnimated3] = useState(new Animated.Value(0.3));
  const [opacitiA3, setOpacitiA3] = useState(new Animated.Value(1));

  useEffect(() => {
    const animationRef = Animated.stagger(1000, [
      Animated.loop(
        Animated.parallel([
          Animated.timing(animated, {
            toValue: 1,
            duration: 3000,
            useNativeDriver: false,
          }),
          Animated.timing(opacitiA, {
            toValue: 0,
            duration: 3000,
            useNativeDriver: false,
          }),
        ]),
      ),
      Animated.loop(
        Animated.parallel([
          Animated.timing(animated2, {
            toValue: 1,
            duration: 3000,
            useNativeDriver: false,
          }),
          Animated.timing(opacitiA2, {
            toValue: 0,
            duration: 3000,
            useNativeDriver: false,
          }),
        ]),
      ),
      Animated.loop(
        Animated.parallel([
          Animated.timing(animated3, {
            toValue: 1,
            duration: 3000,
            useNativeDriver: false,
          }),
          Animated.timing(opacitiA3, {
            toValue: 0,
            duration: 3000,
            useNativeDriver: false,
          }),
        ]),
      ),
    ]);
    animationRef.start();

    return () => {
      animationRef.stop();
    };
  }, [animated, animated2, animated3, opacitiA, opacitiA2, opacitiA3]);

  return (
    <View
      testID={tID('RippleAnimation-View-Container')}
      style={styles.container(size)}
    >
      <Animated.View
        testID={tID('RippleAnimation-AnimatedView-A')}
        style={styles.animateContainer(size, resolvedColor, animated, opacitiA)}
      />
      <Animated.View
        testID={tID('RippleAnimation-AnimatedView-B')}
        style={styles.animateContainer(
          size,
          resolvedColor,
          animated2,
          opacitiA2,
        )}
      />
      <Animated.View
        testID={tID('RippleAnimation-AnimatedView-C')}
        style={styles.animateContainer(
          size,
          resolvedColor,
          animated3,
          opacitiA3,
        )}
      />
      <View style={styles.iconContainer(iconSize, resolvedColor)}>
        {iconType === 'png' ? (
          <Image
            testID={tID('RippleAnimation-Image-Icon')}
            source={icon}
            style={[styles.iconImage(iconSize), imageStyle]}
            resizeMode="contain"
          />
        ) : (
          cloneElement(icon, {
            testID: tID('RippleAnimation-Image-Icon'),
            tintColor: resolvedIconTintColor,
            width: iconSize,
            height: iconSize,
            style: imageStyle,
          })
        )}
      </View>
    </View>
  );
};

export default RippleAnimation;
